import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import FlatButton from 'material-ui/FlatButton';

const style = {
    barContainer: {
        backgroundColor: '#4285f4',
        position: 'fixed',
        paddingTop: '6px',
        paddingBottom: '6px',
        top: 0,
        left: 0
    },
    hide: {
        display: 'none'
    },
    show: {
        display: 'flex'
    }
};

export default class SelectionBar extends Component {
    static propTypes = {
        hidden: PropTypes.bool,
        counter: PropTypes.number,
        handleDownload: PropTypes.func,
        handleClose: PropTypes.func
    };

    static defaultProps = {
        hidden: true
    };

    _handleDownload = () => {
        const {handleDownload} = this.props;

        if (handleDownload) {
            handleDownload();
        }
    };

    _handleClose = () => {
        const {handleClose} = this.props;

        if (handleClose) {
            handleClose();
        }
    };

    render() {
        const {counter, hidden} = this.props;
        const containerStyle = Object.assign(style.barContainer, hidden ? style.hide : style.show);

        return (
            <AppBar
                title={<span>{counter} Selected</span>}
                iconElementLeft={<IconButton onClick={this._handleClose}><NavigationClose /></IconButton>}
                iconElementRight={<FlatButton onClick={this._handleDownload} label="Download"/>}
                style={containerStyle}
            />
        );
    }
}
